<template>
  <Component
    :is="isTruncated ? Tooltip : Primitive"
    :title="value"
    :delay="300"
    :asChild="!isTruncated"
  >
    <label
      class="overflow-hidden"
      :class="{ 'pointer-events-none': readonly }"
      @click="editableRef?.edit()"
    >
      <EditableTextArea
        ref="editableRef"
        :defaultValue="value"
        :cols="1"
        :maxLength="maxLength"
        :showMaxLength="false"
        variant="badge"
        :size="isMobile ? 'md' : 'sm'"
        :placeholder="
          placeholder ?? $t('components.asset_create.unique_id.label')
        "
        :readonly="readonly"
        :submitMode="submitMode"
        :selectOnFocus="selectOnFocus"
        class="text-left font-roboto-mono font-medium has-data-placeholder-shown:truncate"
        :class="{
          'text-secondary': value,
          'text-placeholder': !value,
          'text-[11px] leading-sm': viewport !== 'desktop',
          'text-[10px] leading-xs': viewport === 'desktop',
          'md:text-[10px] md:leading-xs': viewport === 'reactive',
        }"
        @update="$emit('update', $event)"
        @click.prevent
      >
        <template #leading>
          <Icon name="plus" :size="isMobile ? 'md' : 'sm'" />
        </template>
      </EditableTextArea>
    </label>
  </Component>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { Primitive } from "radix-vue";
import { Icon } from "@/SharedComponents/Icon";
import { EditableTextArea } from "@/SharedComponents/Inputs";
import { Tooltip } from "@/SharedComponents/Tooltips";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { isTruncating } from "@/Utils/truncate";

defineEmits(["update"]);

const editableRef = ref(null);

const props = defineProps({
  value: { type: String, required: true },
  maxLength: { type: [String, Number], default: 60 },
  placeholder: { type: String, required: false },
  readonly: { type: Boolean, default: false },
  submitMode: { type: String, default: "both" },
  selectOnFocus: { type: Boolean, default: true },
  viewport: {
    type: String,
    validator: (val) => ["mobile", "desktop", "reactive"].includes(val),
    default: "reactive",
  },
});

const isTruncated = ref(false);

onMounted(() => {
  setTimeout(() => {
    isTruncated.value = isTruncating(editableRef.value?.previewRef?.$el);
  }, 500);
});

const { maxTablet } = useBreakpoints();

const isMobile = computed(() => {
  switch (props.viewport) {
    case "mobile":
      return true;
    case "desktop":
      return false;
    case "reactive":
    default:
      return maxTablet.value;
  }
});
</script>
